import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6f5762e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5 py-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-2" }, "Subscription", -1))
const _hoisted_5 = { class: "text-muted mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_8 = {
  key: 2,
  class: "text-center py-5 text-muted"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spin fa-spinner me-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Loading plans… ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "row g-4 plan-row"
}
const _hoisted_13 = { class: "plan-card-badges" }
const _hoisted_14 = {
  key: 0,
  class: "badge text-bg-primary"
}
const _hoisted_15 = {
  key: 1,
  class: "badge text-bg-success"
}
const _hoisted_16 = { class: "plan-card-title" }
const _hoisted_17 = { class: "plan-card-price" }
const _hoisted_18 = { class: "plan-card-credits text-muted" }
const _hoisted_19 = {
  key: 0,
  class: "plan-card-description text-muted small"
}
const _hoisted_20 = { class: "plan-card-footer mt-auto" }
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "fa fa-spin fa-spinner me-1",
  "aria-hidden": "true"
}
const _hoisted_23 = {
  key: 1,
  class: "plan-card-status text-muted"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-check-circle me-1",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Your workspace is on this plan ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 2,
  class: "plan-card-status text-muted"
}
const _hoisted_28 = {
  key: 4,
  class: "text-muted mt-4 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.pageSubtitle), 1),
        (_ctx.plansError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.plansError), 1))
          : _createCommentVNode("", true),
        (_ctx.actionError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.actionError), 1))
          : _createCommentVNode("", true),
        (_ctx.plansLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedPlans, (plan) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: plan.key,
                  class: "col-12 col-md-6 col-xl-5"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["plan-card h-100", {
                                'plan-card--current': _ctx.isCurrentPlan(plan),
                                'plan-card--upgrade': _ctx.isUpgradeTarget(plan),
                            }])
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.isCurrentPlan(plan))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Current plan"))
                        : _createCommentVNode("", true),
                      (_ctx.isUpgradeTarget(plan))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Next step"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("h3", _hoisted_16, _toDisplayString(plan.label), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(plan.priceLabel), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(plan.monthlyCredits.toLocaleString()) + " credits per " + _toDisplayString(plan.renewalIntervalLabel), 1),
                    (plan.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(plan.description), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.isUpgradeTarget(plan) && _ctx.showActionButton)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary w-100",
                            disabled: _ctx.actionLoading,
                            onClick: _withModifiers(($event: any) => (_ctx.onPlanAction(plan)), ["prevent"])
                          }, [
                            (_ctx.actionLoading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.actionButtonLabel), 1)
                          ], 8, _hoisted_21))
                        : (_ctx.isCurrentPlan(plan))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, " "))
                    ])
                  ], 2)
                ]))
              }), 128))
            ])),
        (!_ctx.plansLoading && !_ctx.showActionButton && _ctx.mode === 'upgrade' && _ctx.currentPlanKey === 'paid')
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, " You are already on the paid plan. No upgrade is available. "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}